<div class="spinner" [ngStyle]="{ 'width.rem': width, 'height.rem': height }" *ngIf="display">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
</div>